
import Q2MySeatCardsBase from "./q2_myseat_cards_base";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";

const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2DeskCards extends Q2MySeatCardsBase{

    @property(cc.Float)
    fadeInDuration: number = 0.2

    @property(cc.Float)
    moveDuration: number = 0.2

    @property(cc.Float)
    startPosOffset: number = 200

    @property(cc.Node)
    nodeMaxStartPos: cc.Node = null

    @property(cc.Node)
    nodePokerHeapPos: cc.Node = null

    protected m_max_start_local_pos: cc.Vec2 = null

    playCardInAnim(codeList: number[], onFinish?: Function){
        let self = this
        let lastLen = this.pokers.length
        let pokers = self.genPokerList(codeList, true, true)
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            poker.showFace(poker.code != 0)
            poker.showBack(poker.code == 0)
            poker.node.position = self.getTargetStartPos(poker, lastLen, codeList.length)
        }
        this.playAdjust(null, onFinish)
    }

    playFirstCardInAnim(codeList: number[], onFinish?: Function){
        let self = this
        let lastLen = this.pokers.length
        let pokers = self.genPokerList(codeList, true, true)
        let pos = this.nodePokersParent.convertToNodeSpaceAR(this.nodePokerHeapPos.parent.convertToWorldSpaceAR(this.nodePokerHeapPos.position))
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            poker.showFace(poker.code != 0)
            poker.showBack(poker.code == 0)
            poker.node.position = pos
        }
        this.playAdjust(null, onFinish)
    }

    playCardOutAnim(codeList: number[], onFinish?: Function){
        let self = this
        let pokerList = []
        let pokers = this.pokers
        for (let i = 0; i < codeList.length; i++) {
            const code = codeList[i];
            for (let index = pokers.length - 1; index >= 0; index--) {
                const poker = pokers[index];
                if(poker.code == code){
                    pokers.splice(index, 1)
                    pokerList.push(poker)
                    break
                }
            }    
        }
        let len = pokers.length
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let targetPos = cc.v2(poker.node.position.x + self.startPosOffset, poker.node.position.y)
            self.playNodeAnim(poker.node, targetPos, cc.Vec2.ONE, self.moveDuration, 0, null, function(){
                self.playFadeAnim(poker.node, 255, 0, self.fadeInDuration, 0, function(){
                    poker.node.opacity = 255
                    poker.hide()
                })                
            })
        }
        self.playAdjust(null, onFinish)
    }

    protected getTargetStartPos(poker: PokerTablePokerBase, totalCol: number, changeCount: number): cc.Vec2{
        return cc.v2(this.getStartPosX(totalCol, changeCount) + this.getIntervalX(totalCol, 1), poker.node.position.y)
    }

    protected getStartPosX(totalCol: number, changeCount: number){
        let posX = this.calcPos(totalCol - 1, 0, totalCol, 1).x + this.startPosOffset * (changeCount)
        if(this.nodeMaxStartPos){
            if(!this.m_max_start_local_pos){
                this.m_max_start_local_pos = this.nodePokersParent.convertToNodeSpaceAR(this.nodeMaxStartPos.parent.convertToWorldSpaceAR(this.nodeMaxStartPos.position))
            }            
            if(this.m_max_start_local_pos.x < posX){
                return this.m_max_start_local_pos.x
            }
        }
        return posX
    }
}
